import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Search, Pin, WifiOff } from 'lucide-react';
import { BorderBeam } from './magicui/border-beam';

// Illustrative InstruKit window: search a model, open the manual, keep it offline.
const results = [
  { title: 'Service manual', meta: 'Rev. C · 214 pages', pinned: true },
  { title: 'Wiring schematics', meta: 'Rev. B · 38 pages' },
  { title: 'Parts & torque tables', meta: 'Rev. C · 22 pages' },
];

export default function ManualCard({ className = '' }) {
  return (
    <div className={`relative overflow-hidden rounded-3xl bg-white p-5 shadow-lift sm:p-6 ${className}`}>
      <div className="flex items-center justify-between border-b border-line pb-4">
        <div className="flex items-center gap-2">
          <span className="size-2.5 rounded-full bg-[#FF5F57]" />
          <span className="size-2.5 rounded-full bg-[#FEBC2E]" />
          <span className="size-2.5 rounded-full bg-[#28C840]" />
        </div>
        <span className="font-mono text-[0.68rem] uppercase tracking-[0.16em] text-ink-3">InstruKit · Field library</span>
      </div>

      <div className="mt-5 flex items-center gap-3 rounded-2xl border border-line bg-mist px-4 py-3">
        <Search className="size-4 text-ink-3" aria-hidden="true" />
        <span className="font-mono text-sm">chiller 30XA-252</span>
        <span className="ml-auto rounded-md bg-white px-1.5 py-0.5 font-mono text-[0.65rem] text-ink-3 shadow-card">Ctrl K</span>
      </div>

      <ul className="mt-3 space-y-2">
        {results.map((r, i) => (
          <motion.li
            key={r.title}
            initial={{ opacity: 0, y: 6 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 + i * 0.12, duration: 0.35 }}
            className="flex items-center gap-3 rounded-2xl border border-line bg-white p-3"
          >
            <span className="inline-flex size-9 items-center justify-center rounded-lg bg-ink text-white">
              <BookOpen className="size-4" aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-medium">{r.title}</span>
              <span className="block font-mono text-[0.7rem] text-ink-3">{r.meta}</span>
            </span>
            {r.pinned && <Pin className="size-4 text-fusion-ember" aria-label="Pinned to kit" />}
          </motion.li>
        ))}
      </ul>

      <div className="mt-3 flex items-center gap-3 rounded-2xl bg-ink p-3.5 text-white">
        <span className="inline-flex size-10 items-center justify-center rounded-xl bg-white/10">
          <WifiOff className="size-5" aria-hidden="true" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Available offline</p>
          <p className="truncate font-mono text-xs text-white/60">Cached for the job site</p>
        </div>
        <span className="rounded-full bg-fusion-ember/20 px-2.5 py-1 font-mono text-[0.68rem] text-[#FFB08F]">Kit · Basement</span>
      </div>

      <BorderBeam size={120} duration={8} colorFrom="#FF7A45" colorTo="#7A4DFF" borderWidth={1.5} />
    </div>
  );
}
